<template>
    <div>
        <section class="row_am app_solution_section">
      <!-- container start -->
       <!-- container start -->
      <div class="container">
        <!-- row start -->
        <div class="terms-conditions-info"  data-aos="fade-up" data-aos-duration="1500" data-aos-delay="100">
               
                <p>
                 Welcome to Harvest Hub, the ultimate social network for rodeo enthusiasts. By accessing or using our app and services, you agree to these Terms and Conditions.
                </p>
                
                
                <h3>TABLE OF CONTENTS</h3>

                <div class="termsblock">
                  <ol>
                    <li @click.prevent="toppad('aot')"><a>Acceptance of Terms</a></li>
                    <li @click.prevent="toppad('egt')"><a>Eligibility</a></li>
                    <li @click.prevent="toppad('ars')"><a>Account Registration & Security</a></li>
                    <li @click.prevent="toppad('cou')"><a>Content Ownership & Usage</a></li>
                    <li @click.prevent="toppad('cg')"><a>Community Guidelines</a></li>
                    <li @click.prevent="toppad('pdc')"><a>Privacy and Data Collection</a></li>
                    <li @click.prevent="toppad('mts')"><a>Modifications to the Service</a></li>
                    <li @click.prevent="toppad('lol')"><a>Limitation of Liability</a></li>
                    <li @click.prevent="toppad('gl')"><a>Governing Law</a></li>
                    <li @click.prevent="toppad('cu')"><a>ConHarvest Hubt Us</a></li>
                    
                  </ol>
                </div>
                <div class="termsbox" id="aot">
                  <h3>1.	Acceptance of Terms</h3>
                  <p>
                    By registering or using the Harvest Hub app, you agree to these Terms, our Privacy Policy, and Deletion Policy. If you do not agree, please refrain from using the platform.
                  </p>
                </div>
                <div class="termsbox" id="egt">
                  <h3>2. Eligibility</h3>
                  <p>Harvest Hub is intended for users aged <strong>13 years or older</strong>. By creating an account, you confirm you meet this requirement.</p>
                  </div>
                <div class="termsbox" id="ars">
                  <h3>3. Account Registration & Security</h3>
                  <ul>
                    <li>Users can sign up using email, Google, or Apple account.</li>
<li>Providing personal information during signup is optional.</li>
<li>You are responsible for keeping your account credentials secure.</li>
<li>Any activities under your account are your responsibility.</li>
                  </ul>
                </div>
                <div class="termsbox" id="cou">
                  <h3>4. Content Ownership & Usage</h3>
                  <ul>
                    <li>You retain ownership of any content you post, including text and images.</li>
                    <li>By posting, you grant Harvest Hub a non-exclusive, royalty-free license to display and distribute your content within the app.</li>
                    <li>Harvest Hub reserves the right to moderate or remove content that violates these Terms.</li>
                  </ul>
                </div>
                <div class="termsbox" id="cg">
                  <h3>5. Community Guidelines</h3>
                  <p>We value respect and safety. Users must not:</p>
                  <ul>
                    <li>Post content that is offensive, illegal, or harmful</li>
                    <li>Harass, impersonate, or threaten others</li>
                    <li>Infringe on privacy or intellectual property rights</li>
                  </ul>
                  <p>Violation of these rules may result in account suspension or removal.</p>
                </div>
                <div class="termsbox" id="pdc">
                  <h3>6. Privacy and Data Collection</h3>
                  <p>We collect data to improve your experience, including:</p>
                  <ul>
                    <li>Profile details and posts</li>
                    <li>Phonebook syncing with explicit user consent</li>
                    <li>Device information for service improvements</li>
                  </ul>
                  <p>Learn more in our <strong><RouterLink to="/privacy-policy">Privacy Policy</RouterLink></strong>.</p>
                </div>
                <div class="termsbox" id="mts">
                  <h3>7. Modifications to the Service</h3>
                  <p>
                    We reserve the right to update, modify, or discontinue features of Harvest Hub at any time. Notifications will be provided for significant changes.
                  </p>
                </div>
                <div class="termsbox" id="lol">
                  <h3>8. Limitation of Liability</h3>
                  <p>
                   Harvest Hub is provided "as is" without warranties. We are not liable for indirect, incidental, or consequential damages arising from the use of our platform.
                 </p>
                </div>
                <div class="termsbox" id="gl">
                  <h3>9. Governing Law</h3>
                  <p>These Terms are governed by the laws of the United States, irrespective of conflict of law principles.</p>
                </div>
                <div class="termsbox" id="cu">
                  <h3>10. ConHarvest Hubt Us</h3>
                  <p>For questions or concerns about these Terms:</p>
                  <p>Email: <a href="#">harvesthub@gmail.com</a></p>
                </div>
                
               
              </div>
        <!-- row end -->
      </div>
      <!-- container end -->
    </section>
    </div>
</template>
<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
const activeSection = ref(null)
const sectionID = ref(null)
const isHighlighted = ref(false)
const isRolled = ref(false)

const props = defineProps({
  isWebTarget: {
    type: Boolean,
    default: false
  }
})


const toppad = (id) => {
  isHighlighted.value = true
  sectionID.value = id
  activeSection.value = id
  const targetElement = document.getElementById(id)
  if(props.isWebTarget){
  
  //console.log(targetElement)
  if (targetElement) {
    targetElement.classList.add('padded-section')
    targetElement.scrollIntoView({ behavior: 'smooth' })

    setTimeout(() => {
      // activeSection.value = null
      // // isHighlighted.value = false
      // targetElement.classList.remove('padded-section')
      isRolled.value = true
    }, 1000) // Adjust timeout based on scroll duration
  }
}
else{
    targetElement.scrollIntoView({ behavior: 'smooth' })
    setTimeout(() => {
      // activeSection.value = null
      // // isHighlighted.value = false
      // targetElement.classList.remove('padded-section')
      isRolled.value = true
    }, 1000) // Adjust timeout based on scroll duration
  }
}


const removeHighlight = () => {
  const element = document.getElementById(sectionID.value)
  if (element) {
    element.classList.remove('padded-section')
    sectionID.value = null
    // isHighlighted.value = false
  }
}


const handleScroll = () => {
  if (isRolled.value) {
    removeHighlight()
  }
  isRolled.value = false
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
/* Your styles here */
.terms {
  margin: 40px 0;
}
.about_us_section .abt_text h2 {
  max-width: 100%;
  margin-bottom: 0px;
}
.terms-conditions-info{margin-top:20px;}
.terms-conditions-info h3 {
  font-weight: 600;
  font-size: 24px;
  margin-bottom: 20px;
  margin-top: 15px;
}

.descriptionArea {
  padding: 60px 0;
}
.descriptionArea h1 {
  margin-bottom: 30px;
}
.termsblock {
  display: block;
}
.termsblock ol {
  list-style: none;
  counter-reset: item;
  margin-left: 20px;
}
.termsblock li {
  counter-increment: item;
  margin-bottom: 5px;
  display: flex;
  text-transform: uppercase;
}
.termsblock li a {
  margin-top: 2px;
  cursor: pointer;
}
.termsblock li:before {
  margin-right: 10px;
  content: counter(item);
  background: #a36043;
  border-radius: 50%;
  color: white;
   width: 28px;
  height: 28px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1px 10px;
}
.termsbox {
  padding-top: 15px;
}
.padded-section {
  padding-top: 115px;
}

.termsbox ul {
  display: block;
  margin: 10px 15px;
  padding: 0;
}
.termsbox ul li {
  display: block;
  line-height: 24px;
  margin-bottom: 12px;
  padding-left: 30px;
  position: relative;
}

.termsbox ul li:before {
  content: '\f005'; /* FontAwesome Unicode */
  font-family: 'Font Awesome 5 Free';
  display: inline-block;
  color: #a36043;
  width: 20px;
  position: absolute;
  top: 0;
  left: 0;
}

.row_am{padding:0px 0 50px 0}

</style>
